import { NODE_ENV } from '@witmetrics/utils/constants';
import { getEnv } from '@witmetrics/utils/env';

const BASE_URL = 'witmetrics.io';
const LOCAL_URL = 'http://localhost';

export const getApiUrl = () => {
  return getUrl(3333, 'api', '/v1');
};

export const getAuthUrl = () => {
  return getUrl(3100, 'auth');
};

export const getStoreUrl = () => {
  return getUrl(3900, 'store');
};

function getUrl(port: number, subdomain: string, path: string = '') {
  const env = getEnv();
  switch (env) {
    case NODE_ENV.DEVELOPMENT:
      return `${LOCAL_URL}:${port}${path}`;
    case NODE_ENV.TESTING:
      return `https://${subdomain}.testing.${BASE_URL}${path}`;
    case NODE_ENV.PRODUCTION:
      return `https://${subdomain}.${BASE_URL}${path}`;
    default:
      throw Error(`Unrecognized environment: "${env}"`);
  }
}

export const getProfilePicUrl = (source: string) => {
  return `${getApiUrl()}/files/profile-picture?key=${encodeURIComponent(
    source
  )}`;
};
